var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "19",
        viewBox: "0 0 20 19",
        width: "20",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M18.809 7.888L2.672 1.098a1.9 1.9 0 0 0-2.004.328A1.965 1.965 0 0 0 .061 3.39l1.436 5.712H8.53a.59.59 0 0 1 .586.594.59.59 0 0 1-.586.595H1.497L.061 16.002c-.182.724.05 1.476.607 1.965a1.9 1.9 0 0 0 2.004.328l16.137-6.79A1.929 1.929 0 0 0 20 9.696c0-.806-.456-1.5-1.191-1.808z",
          fill: "#48B6E7",
          "fill-rule": "nonzero",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }